<div class="container row">

  <app-config-line
    [title]="'Historial dinámico'"
    [description]="'Estas configuraciones se aplicarán y se guardarán en el historial dinámico.'"
    [titleLevel]="8"
    [render]="!filterOptionsBy"
  >
  </app-config-line>
  <app-config-line
    [title]="'Elementos visibles en el historial'"
    [description]="'Elige qué información será mostrada en el panel lateral del historial.'"
    [filterBy]="filterOptionsBy"
  >
  <section body class="mb-3 config-section">
    <div class="config-grid">
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showMovements" (change)="saveConfig()"/>
          Movimientos
        </label>
      </div>
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showStops" (change)="saveConfig()"/>
          Paradas
        </label>
      </div>
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showStartRoute" (change)="saveConfig()"/>
          Inicio de ruta
        </label>
      </div>
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showEndRoute" (change)="saveConfig()"/>
          Fin de ruta
        </label>
      </div>
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showFrames" (change)="saveConfig()"/>
          Tramas
        </label>
      </div>
      <div class="config-item">
        <label>
          <input type="checkbox" [(ngModel)]="config.showEvents" (change)="saveConfig()"/>
          Eventos
        </label>
      </div>
    </div>
  </section>

  </app-config-line>
  <app-config-line
    [title]="'Formato de tramas'"
    [description]="'Selecciona la variante de trama que se utilizará para representar la información en el historial.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Sección 2: Variante de trama -->
    <section body class="mb-3 config-section">
      <div class="config-grid">
        <div class="config-item">
          <label>
            <input
              type="radio"
              name="frameVariant"
              value="basic"
              [(ngModel)]="config.frameVariant"
              (change)="saveConfig()"
            />
            Básica
          </label>
        </div>
        <div class="config-item">
          <label>
            <input
              type="radio"
              name="frameVariant"
              value="speed"
              [(ngModel)]="config.frameVariant"
              (change)="saveConfig()"
            />
            Velocidad
          </label>
        </div>
        <div class="config-item">
          <label>
            <input
              type="radio"
              name="frameVariant"
              value="time"
              [(ngModel)]="config.frameVariant"
              (change)="saveConfig()"
            />
            Tiempo
          </label>
        </div>
        <div class="config-item">
          <label>
            <input
              type="radio"
              name="frameVariant"
              value="speed-time"
              [(ngModel)]="config.frameVariant"
              (change)="saveConfig()"
            />
            Velocidad y tiempo
          </label>
        </div>
      </div>
    </section>

  </app-config-line>
  <app-config-line
    [title]="'Opciones avanzadas de visualización'"
    [description]="'Personaliza cómo se representan las rutas, geocercas y direcciones en el historial.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Sección 3: Opciones adicionales -->
    <section body class="mb-3 config-section">
      <div class="config-grid">
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.routeWithDirection" (change)="saveConfig()" />
            Ruta con dirección
          </label>
        </div>
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.animationDirection" (change)="saveConfig()" />
            Direcciones animadas
          </label>
        </div>
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.routeWithSpeed" (change)="saveConfig()" />
            Ruta de velocidad
          </label>
        </div>
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.showGeofences" (change)="saveConfig()" />
            Mostrar geocercas
          </label>
        </div>
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.showCircularGeofences" (change)="saveConfig()" />
            Geocercas circulares
          </label>
        </div>
        <div class="config-item">
          <label>
            <input type="checkbox" [(ngModel)]="config.showGeopoints" (change)="saveConfig()" />
            Geopuntos
          </label>
        </div>
      </div>
    </section>
  </app-config-line>


  <div *ngIf="messageResponse !== ''" class="message-info">
    <i class="icon_info p-0 m-0">
      <svg width="16" height="16" fill="currentColor">
        <use xlink:href="./assets/icons/sprite.svg#info-circle"></use>
      </svg>
    </i>
    <p class="p-0 m-0">{{ messageResponse }}</p>
  </div>


  <div class="config-actions" *ngIf="!filterOptionsBy">
    <button class="btn-gl-cancel" (click)="resetConfig()">
      Restaurar por defecto
    </button>
  </div>

</div>
